import {connect} from 'react-redux';

export default connect((state, props) => {
    return {
        event: _(state).get(`events[${props.eventId}].event`),
        form: _(state).get(`forms.metadata[${props.formId}]`),
        answer: _(state).get(`forms.drafts[${props.formAnswer}]`),
        i18n: state.i18n.translations
    };
});
